import * as React from 'react';
import Home from './Home';
import PanelPage from './PanelPage';
import ProjectDetail from './ProjectDetail';
import ProjectList from './ProjectList';

export type PageProps = IPageDto;

type Props = PageProps;

class Page extends React.Component<Props> {

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    const body = document.body;
    if (!body || body.classList.contains('hide-intro')) { return };

    setTimeout(() => body.classList.add("hide-intro"), 3000);
  }
  render() {

    return (
      <React.Fragment>

        {this.props.type === "Home" &&
          <Home
            {...this.props as HomeDto}
          />
        }
        {this.props.type === "Projects" &&
          <ProjectList
            {...this.props as ProjectsDto}
          />
        }
        {this.props.type === "PanelPage" &&
          <PanelPage
            {...this.props as PanelPageDto}
          />
        }
        {this.props.type === "Project" &&
          <ProjectDetail
            {...this.props as ProjectDto}
          />
        }
      </React.Fragment>
    );
  };
};

export default Page;



// WEBPACK FOOTER //
// ./src/components/Page.tsx